import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → EOM (C-16 S2, GLE-8409). The page switches on with
 * `user_roles_eom_enabled`, so the entry waits for `manage/me.features.eom`
 * (C16-D425). Window: release 11.5.102 (2026-10-31 ET) to 14 days after,
 * and each LGA and Admin sees it on at most two ET days. Until the switch-on
 * the feature gate keeps it hidden. October 2026 is the first month closed
 * here (Omar, 2026-10-31): Command Center keeps September and earlier as its
 * record.
 */
export const EOM_2026_11: WhatsNewEntryI = {
  id: "2026-11-eom",
  feature: "eom",
  startsAt: "2026-10-31T04:00:00.000Z",
  endsAt: "2026-11-14T05:00:00.000Z",
  title: {
    [LGA]: "Month-end close is now under Team",
    [ADMIN]: "Month-end close is now under Team",
  },
  intro: {
    [LGA]:
      "October closes here, not in Command Center. Check your month-end payout line by line and add your credits and costs; finance reviews each month and closes it.",
    [ADMIN]:
      "Finance reviews and closes October here, not in Command Center: the app drafts each LGA's month, and you check, adjust, lock and mark it paid.",
  },
  sections: [
    {
      id: "eom",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SCORE,
      title: "Team → EOM",
      items: [
        "Each workspace's month: qualified meetings, GMV, LGA bonus, rep incentives, credits and COGS, and the final payout.",
        "Click any number for what it's made of, down to each meeting and charge.",
        "Add credits and COGS, exclude a rep incentive, or dismiss an unpaid carryover while the month is a draft.",
        "AR/AP lists what's owed each way, and when it was paid.",
        "Export the month as a ledger CSV.",
      ],
      link: { label: "Open EOM", href: Router.manageEom() },
    },
    {
      id: "eom-admin",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Admin only",
      items: [
        "Nothing locks or pays by itself: review the draft, then lock the month and tick payouts paid with their proof.",
        "Count a meeting by hand, or exclude and override a row, before you lock.",
        "Sync Stripe charges from the Stripe tab: no more CSV uploads.",
        "QM Contribution: the corrected margin per month, next to Command Center's basis.",
        "September and earlier stay as Command Center closed them.",
      ],
    },
  ],
};
